import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import "animate.css";

import { ProjectCard } from "./ProjectCard";
import { projects } from "../data/projects";
import colorSharp2 from "../assets/img/color-sharp2.png";

export const Projects = () => (
  <section className="project" id="projects">
    <Container>
      <Row>
        <Col xs={12}>
          <TrackVisibility partialVisibility>
            {({ isVisible }) => (
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Projects</h2>
                <p>
                  I have spent more than 10 years producing secure applications and
                  websites across a wide range of projects and industries. My experience
                  spans many different stacks, from WordPress and WooCommerce to React,
                  Next.js, data platforms, automation, and custom full-stack applications.
                  That range lets me choose the right architecture for each project instead
                  of forcing every problem into the same technology.
                </p>

                <Row className={isVisible ? "project-grid animate__animated animate__slideInUp" : "project-grid"}>
                  {projects.map((project, index) => (
                    <ProjectCard
                      key={`${project.title}-${index}`}
                      {...project}
                    />
                  ))}
                </Row>
              </div>
            )}
          </TrackVisibility>
        </Col>
      </Row>
    </Container>
    <img className="background-image-right" src={colorSharp2} alt="" />
  </section>
);
